<template>
  <div class="institutional">
    <div class="head">
      <p class="title">{{ $t('openAccount.t000145') }}</p>
    </div>
    <div class="info-box">
      <div class="ipt-box" :class="{ focus: inputFocusId == 1 }">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 1 || form.real_name"
              >{{ $t('openAccount.t000146') }}</span
            >
            <Field
              class="val"
              v-model="form.real_name"
              :placeholder="inputFocusId == 1 ? '' : $t('openAccount.t000146')"
              @focus="inputFocus(1)"
              @blur="inputBlur"
              :formatter="formatCn"
            ></Field>
          </div>
        </div>
      </div>
      <div class="ipt-box" :class="{ focus: inputFocusId == 2 }">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 2 || form.english_name"
              >{{$t('openAccount.t000147')}}</span
            >
            <Field
              class="val"
              v-model="form.english_name"
              :placeholder="inputFocusId == 2 ? '' : $t('openAccount.t000147')"
              :formatter="formatVal"
              @focus="inputFocus(2)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
      </div>
      <div class="ipt-box" :class="{ error: isClickNext && !form.birth }">
        <div class="ipt-main" @click="openPickerPopup('birth')">
          <div class="val-box">
            <span class="label" :class="{ placeholder: !form.birth }"
              >{{$t('openAccount.t000148')}}</span
            >
            <span class="val" v-if="form.birth">{{ form.birth }} </span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{$t('openAccount.t000149')}}</p>
      </div>
      <div
        class="ipt-box"
        :class="{ error: isClickNext && !form.register_address }"
      >
        <div class="ipt-main" @click="openPickerPopup('register_address')">
          <div class="val-box">
            <span class="label" :class="{ placeholder: !form.register_address }"
              >{{$t('openAccount.t000150')}}</span
            >
            <span class="val" v-if="registerAddressText"
              >{{ registerAddressText }}
            </span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{$t('openAccount.t000150')}}</p>
      </div>
      <div
        class="ipt-box"
        :class="{
          focus: inputFocusId == 3,
          error: isClickNext && !form.id_card
        }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 3 || form.id_card">{{
              idCardText
            }}</span>
            <Field
              class="val"
              v-model="form.id_card"
              :placeholder="inputFocusId == 3 ? '' : idCardText"
              @focus="inputFocus(3)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000155') }}</p>
      </div>
      <div
        class="ipt-box"
        :class="{
          focus: inputFocusId == 4,
          error: isClickNext && !form.company_address
        }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 4 || form.company_address"
              >{{ $t('openAccount.t000156') }}</span
            >
            <Field
              class="val"
              v-model="form.company_address"
              :placeholder="inputFocusId == 4 ? '' : $t('openAccount.t000156')"
              @focus="inputFocus(4)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000157') }}</p>
      </div>
      <div
        class="ipt-box"
        :class="{
          focus: inputFocusId == 5,
          error: isClickNext && !form.company_phone
        }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 5 || form.company_phone"
              >{{ $t('openAccount.t000158') }}</span
            >
            <Field
              class="val"
              v-model="form.company_phone"
              :placeholder="inputFocusId == 5 ? '' : $t('openAccount.t000158')"
              @focus="inputFocus(5)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{$t('openAccount.t000159')}}</p>
      </div>
      <div
        class="ipt-box email"
        :class="{ focus: inputFocusId == 6, error: isClickNext && !form.email }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 6 || form.email"
              >{{ $t('openAccount.t000160') }}</span
            >
            <Field
              class="val"
              v-model="form.email"
              :placeholder="inputFocusId == 6 ? '' : $t('openAccount.t000160')"
              :formatter="formatMail"
              @focus="inputFocus(6)"
            ></Field>
          </div>
          <div class="suffix-email-box" v-if="isShowSubffixBox">
            <div class="list">
              <template v-for="item in emailSuffixList">
                <div
                  v-if="item.includes(form.email.split('@')[1])"
                  class="item"
                  :key="item"
                  @click="subffixSelect(item)"
                >
                  {{ item }}
                </div>
              </template>
            </div>
            <div class="mask"></div>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000161') }}</p>
        <p class="error show orange">
          {{ $t('openAccount.t000162') }}
        </p>
      </div>
      <div
        class="ipt-box"
        :class="{
          focus: inputFocusId == 7,
          error: isClickNext && !form.executive_director
        }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span
              class="label"
              v-if="inputFocusId == 7 || form.executive_director"
              >{{$t('openAccount.t000163')}}</span
            >
            <Field
              class="val"
              v-model="form.executive_director"
              :placeholder="inputFocusId == 7 ? '' : $t('openAccount.t000163')"
              @focus="inputFocus(7)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('openAccount.t000164') }}</p>
      </div>
    </div>
    <NavButtons @on-next="next" :disabled="!icCanNext" />

    <!--    时间选择 -->
    <van-popup v-model="showPickerPopup" position="bottom" class="picker-popup picker-ui">
      <template v-if="pickerRef == 'birth'">
        <p class="date-title">{{ $t('openAccount.t000165') }}</p>
        <van-datetime-picker
          type="date"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="pickerPopupConfirm"
          @cancel="showPickerPopup = false"
        />
      </template>
      <template v-if="pickerRef == 'register_address'">
        <p class="date-title">{{ $t('openAccount.t000166') }}</p>
        <van-picker
          show-toolbar
          value-key="value_display"
          :columns="registerAddressColumns"
          :default-index="regAddsdefaultIndex"
          @confirm="pickerPopupConfirm"
          @cancel="pickerPopupConcel"
        />
      </template>
    </van-popup>
    <van-dialog v-model="emailResultShow" class="email-dialog" :showConfirmButton="false" title="">
      <div class="dialog-title">{{ $t('personalInformation.error_tip.lang9') }}</div>
      <div class="dialog-content">{{ $t('personalInformation.error_tip.lang10') }}</div>
      <div class="dialog-tip">{{ $t('personalInformation.error_tip.lang11') }}</div>
      <div class="dialog-confirm">
        <div class="confirm-btn" @click="toNextPage()">{{ $t('personalInformation.error_tip.lang12') }}</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { DatetimePicker, Dialog, Field, Picker, Popup, Toast } from "vant";
import { formatDate } from "@/utils/date";
import NavButtons from "@/views/open-account/components/navButtons.vue";
import { isEmail, PhoneNum } from "@/utils/verify";

export default {
  name: "InstitutionalPage",
  components: {
    NavButtons,
    Field,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    minDate() {
      const date = new Date();
      const y = date.getFullYear() - 100;
      return new Date(y + "/" + "1/1");
    },
    maxDate() {
      const date = new Date();
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return new Date(y + "/" + m + "/" + d);
    },
    registerAddressText() {
      let text = "";
      const _item = this.registerAddressColumns?.find?.(
        item => item.value == this.form.register_address
      );
      if (_item) text = _item.value_display;
      return text;
    },
    // 不同注册地址 登记号码 label 不同
    idCardText() {
      const texts = {
        1: this.$t('openAccount.t000152'),
        2: this.$t('openAccount.t000153'),
        3: this.$t('openAccount.t000154')
      };
      return texts[this.form.register_address];
    },
    // 是否显示 邮箱 提示下拉框
    isShowSubffixBox() {
      return (
        this.form.email &&
        (this.form.email.indexOf("@") < 0 ||
          this.form.email.indexOf(".") < 0) &&
        this.inputFocusId == 6
      );
    },
    // 是否可以下一步
    icCanNext(){
      const { real_name, english_name, ...otherkeys } = this.form;
      let result = true;
      for (const key in otherkeys) {
        if (otherkeys[key] == null || otherkeys[key] === "") { // 检查null, undefined 和 空字符串
          result = false;
        }
      }
      return result && (real_name || english_name);
    }
  },
  data() {
    return {
      form: {
        real_name: "",
        english_name: "",
        birth: "",
        register_address: "1",
        id_card: "",
        company_address: "",
        company_phone: "",
        email: "",
        executive_director: ""
      },
      inputFocusId: 0,
      isClickNext: false,
      showPickerPopup: false,
      currentDate: new Date(),
      pickerRef: "",
      registerAddressColumns: [],
      regAddsdefaultIndex: 0,
      emailSuffixList: [],
      emailResultShow: false
    };
  },
  created() {
    const institutionalForm = localStorage.getItem('institutionalForm');
    if(institutionalForm){
      this.form = JSON.parse(institutionalForm);
    }
    this.getEnumData();
  },
  methods: {
    formatVal(e) {
      return e.replace(/[\u4e00-\u9fa5]/g, "");
    },
    formatMail(e){
      return e.replace(/[\s\u4e00-\u9fa5]/g, "")
    },
    inputFocus(id) {
      this.inputFocusId = id;
      if (id === 6) {
        // 滚动到顶部
        const app = document.getElementById("app");
        app.scrollTop = 1000;
      }
    },
    formatCn(e){
      return e.replace(/[^\u4e00-\u9fa5]/g, '')
    },
    inputBlur() {
      this.inputFocusId = null;
    },
    openPickerPopup(ref) {
      this.showPickerPopup = true;
      this.pickerRef = ref;
    },
    pickerPopupConcel() {
      this.showPickerPopup = false;
      this.pickerRef = null;
    },
    pickerPopupConfirm(e, i) {
      if (this.pickerRef == "birth") {
        this.form.birth = formatDate(this.currentDate, "yyyy-MM-dd");
      } else if (this.pickerRef == "register_address") {
        
        this.form.register_address = e.value;
        this.regAddsdefaultIndex = i;
      }
      this.showPickerPopup = false;
    },
    getEnumData() {
      // 注册地址枚举
      this.$apis.getEnum({ key: "registerPlace" }).then(res => {
        this.registerAddressColumns = res;
        this.regAddsdefaultIndex = res?.findIndex(
          item => item.value == this.form.register_address
        );
      });
      this.$apis.getEnum({ key: "emailSuffix" }).then(res => {
        
        this.emailSuffixList = res?.[0]?.value_display?.split(",") || [];
      });
      // 邮箱下拉枚举
    },
    // 邮箱下拉选
    subffixSelect(e) {
      if (this.form.email.indexOf("@") > -1) {
        this.form.email = `${this.form.email.split("@")[0]}`;
      }
      this.inputFocusId = 6;
      this.form.email = `${this.form.email}${e}`;
    },
    async next() {
      // 机构中文名称 + 英文名字 得填写一个
      localStorage.setItem('institutionalForm', JSON.stringify(this.form))
      const { real_name, english_name } = this.form;
      if (!real_name && !english_name) {
        this.$toast(this.$t("openAccount.t000167"));
        return false;
      }
      this.isClickNext = true;
      if(!this.icCanNext){
        return false;
      }
      if (!isEmail(this.form.email)){
        this.$toast.fail(this.$t("common.email_verify_fail_text"))
        return false;
      }
      
      if(PhoneNum(this.form.company_phone) === false){
        this.$toast.fail(this.$t("openAccount.t000168"))
        return false;
      }
      this.form.email = this.form.email.trim();
      try {
        const checkEmail = await this.$apis.accountSendEmail({ email: this.form.email })
        if(checkEmail.is_pass == 0){
          return Toast(this.$t('personalInformation.emailErrorTip'))
        }
      }catch (e) {

      }
      this.$apis.saveCompanyInfo(this.form).then(res => {
        // 显示 右键 已发送弹窗
        this.emailResultShow = true;
      });
    },
    toNextPage(){
      this.emailResultShow = false;
      this.$router.push({
        path: "/open-account/openInstitutionServices"
      });
    }
  }
};
</script>

<style scoped lang="less">
.institutional {
  padding-bottom: 220px;
  .head {
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      color: #17161c;
      font-size: 36px;
      font-weight: 500;
      line-height: 88px;
    }
    .sub {
      color: #f24e1e;
      font-size: 24px;
    }
  }
  .info-box {
    margin-top: 32px;
    padding: 0 32px;
  }

  .date-title {
    line-height: 96px;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
  }
}

.suffix-email-box {
  position: absolute;
  top: 100%;
  left: -4px;
  right: -4px;
  z-index: 3;
  .list {
    background: #fff;
    box-shadow: 0px 0px 0.16rem 0px rgba(23, 22, 28, 0.08);
    border-radius: 8px;
    position: relative;
    z-index: 4;
    max-height: 300px;
    overflow-y: auto;
    .item {
      padding: 30px 32px;
      line-height: 1;
      font-size: 32px;
    }
  }
}

.ipt-box {
  margin-bottom: 24px;
  position: relative;
  &.email {
    z-index: 4;
  }
  &.focus {
    .ipt-main {
      &:after {
        border-color: #17161c;
      }
      ::v-deep .van-cell {
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error {
    .ipt-main {
      &:after {
        border-color: #fd2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      z-index: 3;
      flex: 1;
      display: flex;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni {
        0% {
          font-size: 28px;
        }
        100% {
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        transform: translate3d(0, 0, 0);
        animation: labelAni 0.2s 0.1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input {
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
          &::placeholder {
            font-size: 28px;
          }
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show {
      display: block;
    }
    &.right {
      text-align: right;
    }
    &.orange {
      color: #f24e1e;
    }
  }
  &.error {
    .ipt-main {
      border-color: #fd2626;
    }
    .error {
      display: block;
    }
  }
}
.picker-popup {
  border-radius: 32px 32px 0 0;
  padding-top: 32px;
}
.email-dialog{
  .dialog-title {
    width: 100%;
    text-align: center;
    color: #17161C;
    font-size: 36px;
    font-weight: 500;
    margin-top: 46px;
  }
  .dialog-content {
    width: 100%;
    text-align: center;
    color: #747377;
    font-size: 32px;
    font-weight: 400;
    margin-top: 32px;
  }

  .dialog-tip {
    width: 100%;
    text-align: center;
    color: #F24E1E;
    font-size: 28px;
    font-weight: 400;
    margin-top: 16px;
  }

  .dialog-confirm {
    width: 100%;
    margin-top: 48px;
    margin-bottom: 56px;
    .confirm-btn {
      width: 496px;
      height: 104px;
      text-align: center;
      line-height: 104px;
      background: #17161C;
      color: #FFFFFF;
      font-size: 28px;
      font-weight: 500;
      border-radius: 200px;
      margin: 0 auto;
    }
  }
  /deep/ .van-dialog__content {
    padding-top: 0px !important;
  }
  /deep/ .van-dialog__footer {
    padding-bottom: 0px !important;
  }
}


.black-theme {
  .suffix-email-box{
    .list{
      background: #14151D;
      color: #fff;
    }
  }
  .email-dialog{
    background: #1B1C24;
    .dialog-title{
      color: #FFFFFF;
    }
    .dialog-content{
      color: #9D9D9F;
    }
    .confirm-btn{
      background: #377CFB;
    }
  }
  .head {
    .title {
      color: #fff;
    }
    border-color: rgba(50, 52, 66, 0.5);
  }
  .ipt-box {
    &.focus {
      .ipt-main {
        &:after {
          border-color: rgba(255, 255, 255, 1);
        }
      }
    }
    &.error {
      .ipt-main {
        &:after {
          border-color: #fd2626;
        }
      }
    }
    .ipt-main {
      &:after {
        border-color: rgba(255, 255, 255, 0.25);
      }
      .label {
        color: #9d9d9f;
      }
      .icon-arrow {
        background: url("../../../assets/images/open-account/dark_icon.png")
          no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val {
        color: #fff;
        ::v-deep {
          .van-cell__value input::placeholder {
            color: #9d9d9f !important;
          }
          textarea {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
